import { render, staticRenderFns } from "./ProblemCreateForm.vue?vue&type=template&id=0ed73798"
import script from "./ProblemCreateForm.vue?vue&type=script&lang=js"
export * from "./ProblemCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports